var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WeInput',{staticClass:"mb-0",attrs:{"prepend":_vm.filterIcon,"small-size":true},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }